import { render, staticRenderFns } from "./chip-primary3.vue?vue&type=template&id=0b5b56f8&scoped=true&"
import script from "./chip-primary3.vue?vue&type=script&lang=js&"
export * from "./chip-primary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b56f8",
  null
  
)

export default component.exports